import React from "react";
import App from "./App";
import "./style.css";

export default function IntegratedVoiceApp() {
  return (
    <div className="agent-shell-voice">
      <App />
    </div>
  );
}
